import { gql } from '@apollo/client';

export const GET_LIVE_FIXTURES = gql`
query LiveFixtures($token: String!, $compId: String) {
    liveFixtures(token: $token, compId: $compId) {
        id
        aetFixtureId
        extFixtureId
        competitionName
        fixtureName
        startDateTime
        aecheckdatasource {
            catName
            catLabel
            enabled
            subCatList {
                catName
                catLabel
                enabled
            }
        }
    }
}`;

export const GET_LIVE_COMPETITIONS = gql`
query GetFinishedCompetitions($dbName: String, $token: String!) {
    getFinishedCompetitions(dbName: $dbName , token: $token) {
            extCompetitionId
            competitionName
            aetCompetitionId
    }
}`;
